<div class="richiestaGaranzia">
    <nav>
        <ul class="nav-wrapper">
            <li><a mat-raised-button color="primary" [routerLink]="['/matricole']">{{'Richiesta di garanzia'|translate}}</a></li><span>&raquo;</span><li *ngIf="selezionato"><a  mat-raised-button color="accent">{{selezionato.codice}}</a></li><li *ngIf="!selezionato"><a  mat-raised-button color="accent">{{'Richiesta libera'|translate}}</a></li>
        </ul>
    </nav>
    <div  *ngIf="inviata"><mat-card>
            <p>{{'Richiesta di garanzia con codice '|translate}}'{{garanzia.codice}}'{{' inviata.'|translate}}<br>
                {{'Verrete contattati a breve dal nostro responsabile commerciale.'|translate}}</p>
        </mat-card>
    </div>
    <div  *ngIf="!inviata">
        <form #garanziaForm="ngForm"  (ngSubmit)="inviaRichiesta()">
            <mat-card>

                <div *ngIf="selezionato" class="fotoMatricola bgfix" [ngStyle]="{'background-image': 'url(' + foto + ')'}"></div>
                <div class="datiMatricola">

                    <mat-input-container>
                        <input [(ngModel)]="garanzia.serialNo" maxlength="20" name="matricola" matInput placeholder="{{'Matricola'|translate}}" required="{{'Richiesto'|translate}}" [disabled]="selezionato && selezionato.id>0 ? true : null">
                    </mat-input-container>
                    <mat-input-container>
                        <input [(ngModel)]="garanzia.codiceMacchina" name="macchina" maxlength="20" matInput placeholder="{{'Codice macchina'|translate}}" [disabled]="selezionato && selezionato.id>0 ? true : null">
                    </mat-input-container><br>
                    <div class="singolo">
                        <mat-input-container>
                            <input [(ngModel)]="garanzia.modello" name="modello" matInput placeholder="{{'Modello'|translate}}" [disabled]="selezionato && selezionato.id>0 ? true : null">
                        </mat-input-container>
                    </div>
                    <mat-input-container>
                        <input name="dataVendita" [max]="oggi" placeholder="{{'Data di vendita'|translate}}" required="{{'Richiesto'|translate}}" [(ngModel)]="garanzia.dataVendita" matInput [matDatepicker]="dataV">
                               <a matSuffix class="calendario" (click)="dataV.open()"><i class="material-icons">&#xE916;</i></a>
                    </mat-input-container>
                    <mat-datepicker #dataV></mat-datepicker>
                    <mat-input-container>
                        <input name="dataRottura" [max]="oggi"  placeholder="{{'Data del guasto'|translate}}" required="{{'Richiesto'|translate}}" [(ngModel)]="garanzia.dataRottura" matInput [matDatepicker]="dataR">
                               <a matSuffix class="calendario" (click)="dataR.open()"><i class="material-icons">&#xE916;</i></a>
                    </mat-input-container>
                    <mat-datepicker #dataR></mat-datepicker>
                    <div class="singolo">
                        <mat-input-container>
                            <input [(ngModel)]="garanzia.email" type="email" name="email" matInput placeholder="{{'Email'|translate}}">
                        </mat-input-container>
                    </div>
                    <div class="singolo">
                        <mat-input-container>
                            <textarea matInput name="indirizzo" placeholder="{{'Indirizzo'|translate}}" [(ngModel)]="garanzia.indirizzo"></textarea>
                        </mat-input-container>
                    </div>
                    <a *ngIf="selezionato && utente" href="https://ghibli.ricambio.net/site/pagece5.wplus?ID_COUNT=ce_5_home&LN={{utente.lingua}}&CEPV=Ghibli002&CELN={{utente.lingua}}&CEME=2&CEOP=LOGOUTCE5&AUTOSTARTCEPV=1&CEURLGET_UID={{utente.uid}}&CEURLGET_usertype=g&CEURLGET_SessionID={{utente.sessionUID}}&UID={{utente.uid}}&SESSIONID={{utente.sessionUID}}&IDSCOD={{garanzia.codiceMacchina}}" target="_blank" mat-raised-button color="bottone" >{{'Ricambistica'|translate}}</a>

                    <div class="msgcompila" *ngIf="!garanziaForm.form.valid">{{'Compilare tutti i campi contrassegnati con *'|translate}}</div>
                </div>

            </mat-card>

            <mat-card class="righe-carrello" >

                <h1 class="titologriglia">{{'Componenti sostituiti'|translate}}</h1>
                <table mat-data-table class="mat-data-table" cellpadding="0" cellspacing="0" width="100%">
                    <thead>
                        <tr>

                            <th>
                                <span>{{'Codice'|translate}}</span><sup>*</sup>
                            </th>
                            <th width="40%">
                                <span>{{'Descrizione'|translate}}</span><sup>&nbsp;</sup>
                            </th>

                            <th class="number" width="50">
                                <span>{{'Qta'|translate}}</span><sup>&nbsp;</sup>
                            </th>
                            <th width="40%">
                                <span>{{'Difetto riscontrato'|translate}}</span><sup>*</sup>
                            </th>
                            <th>
                                <span>&nbsp;</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                    <ng-container *ngFor="let r of garanzia.righe">
                        <tr grid-item  *ngIf="r.id>-1">
                        <td class="codiceRiga"><ng2-completer width="100%" [(ngModel)]="r.codice" name="codice_{{r.id}}" (selected)="selezionatoEvento($event,r);" [datasource]="dataService" [minSearchLength]="0"></ng2-completer></td>
                        
                        
                            <td><input [(ngModel)]="r.descrizione" name="descrizione_{{r.id}}" type="text" width="100%" /></td>
                            <td class="number"><input [(ngModel)]="r.qta" name="qta_{{r.id}}" type="number" min="1" step="1" size="2" /></td>
                            <td><textarea [(ngModel)]="r.testo" name="testo_{{r.id}}" type="text" width="100%" ></textarea></td>
                            <td><a class="rimuovi" (click)="rimuoviRiga(r)"><i class="material-icons">&#xE872;</i></a></td>
                        </tr>
                    </ng-container>
                    </tbody>
                </table><br>
                <a *ngIf="!garanzia.righe || garanzia.righe.length<11" style="float:right;" mat-raised-button color="bottonebianco"  (click)="aggiungiRiga()">{{'Aggiungi nuova riga'|translate}}</a><br>
            </mat-card>
            <mat-card  class="formGaranzia">
                <mat-input-container>
                    <textarea matInput name="testo" placeholder="{{'Note ulteriori'|translate}}" [(ngModel)]="garanzia.testo"></textarea>
                </mat-input-container><br>
                <input #fileInput type="file" id="fileUpload" class="fileUpload" (change)="onChange($event)"/>
                <label class='icon' for='fileUpload'>
                    <span class='icona' style="color:#333;"><i class="material-icons">&#xE864;</i></span>&nbsp;<span class='testo' *ngIf="!fileSelezionato">{{'Inserisci una foto'|translate}}</span> <span class='testo' *ngIf="fileSelezionato">{{'file scelto'|translate}}{{fileSelezionato.name}} </span>
                </label><br>
                <br>
                <br>
                <div *ngIf="formErrors.general" class="alert alert-danger">
                    {{ formErrors.general }}
                </div>
                <button type="submit" mat-raised-button color="bottone"  [disabled]="!garanziaForm.form.valid">{{'Invia richiesta'|translate}}</button>
            </mat-card>
        </form>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/tws-garanzia/tws-garanzia.component.html